import { useState, useCallback, useRef } from 'react';

import { SearchDrawer } from '../../../../../../../../../components/SearchDrawer';
import {
  PrimaryListing,
  type Props as PrimaryListingProps,
} from './PrimaryListing';
import {
  SecondaryListing,
  type Props as SecondaryListingProps,
} from './SecondaryListing';

type Option = PrimaryListingProps | SecondaryListingProps;

interface Props {
  options: Option[];
  onSelect?: (id: string) => void;
  inputValue?: string;
  onInputChange?: (value: string) => void;
  onCancel?: () => void;
  status: 'pending' | 'success' | 'error';
}

export const MobileField = ({
  options,
  onSelect,
  inputValue,
  onInputChange,
  onCancel,
  status,
}: Props) => {
  const [open, setOpen] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleSelectionChange = useCallback(
    (keys) => {
      setOpen(false);
      onSelect?.(String(...keys));
    },
    [onSelect, setOpen]
  );

  const handleInputChange = useCallback(
    (value?: string) => {
      if (value === undefined) return;
      onInputChange?.(value);
    },
    [onInputChange]
  );

  const handleCancel = useCallback(() => {
    setOpen(false);
    onCancel?.();
  }, [onCancel]);

  return (
    open && (
      <div ref={containerRef}>
        <SearchDrawer
          label="Select a ticker"
          placeholder="Search for a ticker"
          items={options}
          inputValue={inputValue}
          onCancel={handleCancel}
          onSelectionChange={handleSelectionChange}
          onInputChange={handleInputChange}
          emptyStateRender={() => {
            return (
              <div className="grid justify-center">
                <div className="mt-2 min-h-x5 px-x1_25 text-soft">
                  Couldn't find any matching items
                </div>
              </div>
            );
          }}
          status={status}
          containerRef={containerRef}
        >
          {(item) => (
            <SearchDrawer.Option
              textValue={item.label}
              key={item.id}
              className="border-0 border-b border-solid border-subtle"
            >
              {item.type === 'primary' ? (
                <PrimaryListing {...item} />
              ) : (
                <SecondaryListing {...item} />
              )}
            </SearchDrawer.Option>
          )}
        </SearchDrawer>
      </div>
    )
  );
};
